const tag = ({ text, color }) => (
  <span style={{ backgroundColor: color }} className="tag">
    {text}
  </span>
);

export default tag;
